import Api from '../Base'

class GetShelfProductById extends Api {
  requestUrl = `/api/shelfProduct/${this.getParams().shelfProductId}`
}

export default GetShelfProductById
